module.exports = __webpack_public_path__ + "img/routers.9bd4ceea.svg";